export default __webpack_public_path__ + "static/media/EngineeringRoads_04.836de554.png";